const RANGEPDF = {
  hints: 'hints',
  testdrive: 'testdrive',
  code: 'code',

  values: {
    hints: 'Hints Request',
    testdrive: 'Test Drive Request',
    code: 'Code Request',
  },

  codes: {
    hints: process.env.REACT_APP_CAMPAIGN_CODE_HINTS,
    testdrive: process.env.REACT_APP_CAMPAIGN_CODE_TESTDRIVE,
    code: process.env.REACT_APP_CAMPAIGN_CODE_CODE,
  }
};

export default RANGEPDF;
